var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-source-page',{attrs:{"type":_vm.type,"columns":_vm.columns,"form-columns":_vm.formColumns,"filter-columns":_vm.filterColumns,"form":_vm.form,"title":_vm.$t('model.user'),"actions":_vm.actions,"batch-actions":_vm.batchActions,"resource":"users"}})
}
var staticRenderFns = []

export { render, staticRenderFns }